module.exports = __webpack_public_path__ + "static/media/demo gif 10fps.bae56727.gif";